import { formatarIdadeRelativa } from '@/helpers/formatacao.helpers';
import type { FrescorDados } from '@/types/status.types';

type AvisoDesatualizadoProps = {
  frescor: FrescorDados;
  idadeSegundos: number;
  atualizando: boolean;
  aoAtualizar: () => void;
};

/**
 * Aviso de que os dados em tela podem não refletir o estado atual.
 *
 * Aparece antes de qualquer outro conteúdo: se o próprio monitoramento está calado,
 * o leitor precisa saber disso antes de interpretar os quadradinhos verdes abaixo.
 */
export const AvisoDesatualizado = ({
  frescor,
  idadeSegundos,
  atualizando,
  aoAtualizar,
}: AvisoDesatualizadoProps) => {
  if (frescor === 'atual') {
    return null;
  }

  const obsoleto = frescor === 'obsoleto';
  const cor = obsoleto ? 'var(--danger-active)' : 'var(--warning-active)';

  return (
    <section
      role="status"
      className="cartao-status flex flex-wrap items-center gap-x-4 gap-y-2 py-4"
      style={{ borderLeft: `3px solid ${cor}` }}
    >
      <div className="min-w-0 flex-1">
        <p className="m-0 text-[14px] font-medium" style={{ color: cor }}>
          {obsoleto
            ? 'Não recebemos atualizações do monitoramento'
            : 'Estes dados podem estar desatualizados'}
        </p>
        <p className="mt-1 mb-0 text-[13px] leading-[1.5] text-pretty text-muted-foreground">
          {obsoleto
            ? `A última verificação foi ${formatarIdadeRelativa(idadeSegundos)}. Enquanto isso, não podemos confirmar o estado dos serviços.`
            : `A última verificação foi ${formatarIdadeRelativa(idadeSegundos)}. Estamos tentando atualizar.`}
        </p>
      </div>
      <button
        type="button"
        onClick={aoAtualizar}
        disabled={atualizando}
        className="rounded-lg border border-border bg-transparent px-3 py-1.5 text-[13px] font-medium text-foreground transition-colors hover:bg-accent disabled:opacity-60"
      >
        {atualizando ? 'Atualizando…' : 'Tentar agora'}
      </button>
    </section>
  );
};
